import React, { useState, useContext } from 'react';
import { Container, Typography, Box, Grid, TextField, Button, Paper, Snackbar, Alert } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SendIcon from '@mui/icons-material/Send';
import '../styles/css/Contact.css';
import { LanguageContext } from '../App';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  
  const [formErrors, setFormErrors] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { language, translations } = useContext(LanguageContext);

  // Add these helpers
  const isRTL = language === 'he';
  const fieldDirection = isRTL ? 'rtl' : 'ltr';
  const fieldTextAlign = isRTL ? 'right' : 'left';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    
    // Clear error when typing
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: null
      });
    }
  };

  const validateForm = () => {
    const errors = {};
    
    if (!formData.name.trim()) {
      errors.name = 'שם הוא שדה חובה';
    }
    
    if (!formData.email.trim()) {
      errors.email = 'אימייל הוא שדה חובה';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = 'כתובת אימייל לא תקינה';
    }
    
    if (!formData.message.trim()) {
      errors.message = 'הודעה היא שדה חובה';
    }
    
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    
    setIsSubmitting(true);
    
    // Directly submit the form without showing the success message
    // The form will navigate away from the page, so any code after this
    // will not execute unless there's an error
    try {
      const form = e.target;
      form.submit();
    } catch (error) {
      console.error('Error submitting form:', error);
      setFormErrors({
        submit: 'שגיאה בשליחת הטופס. אנא נסה שוב מאוחר יותר.'
      });
      setIsSubmitting(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <Box className="contact-section" sx={{ backgroundColor: '#f8f8f8' }} >
      <Container className="contact-container">
        <Typography variant="h2" component="h2" className="section-title">
          {translations[language].contactTitle}
        </Typography>
        <Typography variant="subtitle1" className="section-subtitle">
          {translations[language].contactSubtitle}
        </Typography>
        <Typography variant="subtitle1" className="section-subtitle">
          {translations[language].contactSubtitle2}
        </Typography>
                
          <Box className="contact-info-container">
            <Box className="contact-info">
              <Typography variant="h5" component="h3" gutterBottom>
                {translations[language].contactInfoTitle}
              </Typography>

              <Box className="contact-method">
                <PhoneIcon className="contact-icon" />
                <Box>
                  <Typography variant="subtitle2">
                    {translations[language].contactPhoneTitle}
                  </Typography>
                  <Typography variant="body1">
                    <a href="tel:+97252-4636767" style={{ textDecoration: 'none', color: 'inherit' }}>
                      052-4636767
                    </a>
                  </Typography>
                </Box>
              </Box>
              
              <Box className="contact-method">
                <WhatsAppIcon className="contact-icon" />
                <Box>
                  <Typography variant="subtitle2">
                    {translations[language].contactWhatsappTitle}
                  </Typography>
                  <Typography variant="body1" dir="ltr">
                    <a href="https://wa.me/972524636767" style={{ textDecoration: 'none', color: 'inherit' }}>
                      +972-52-4636767
                    </a>
                  </Typography>
                </Box>
              </Box>
              
              <Box className="contact-method">
                <EmailIcon className="contact-icon" />
                <Box>
                  <Typography variant="subtitle2">
                    {translations[language].contactEmailTitle}
                  </Typography>
                  <Typography variant="body1">
                    <a href="mailto:info@studiorami.click" style={{ textDecoration: 'none', color: 'inherit' }}>
                      info@studiorami.click
                    </a>
                  </Typography>
                </Box>
              </Box>
              
                                   
            </Box>
          </Box>

          <Box className="mobile-actionbar">
            <a className="action-btn whatsapp" href="https://wa.me/972524636767" target="_blank" rel="noreferrer">
              WhatsApp
            </a>
            <a className="action-btn phone" href="tel:+972524636767">
              {translations[language].contactPhoneTitle}
            </a>
</Box>
      </Container>
      
      <Snackbar 
        open={snackbarOpen} 
        autoHideDuration={6000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
          {translations[language].contactFormSuccess}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default Contact;
